  <template>
      <div>
          <div class="wrapper">
              <div class="header">
                  <div style="display: flex;margin-top: 2px;margin-right: 10px;align-items: center;justify-content:
  space-between;width: 100%;">
                      <div></div>
                      <div style="display: flex;align-items: center;">
                          <div style="display: flex;margin-top: 2px;">
                              <input v-model="searchValue" type="text" @input="searchInput"
                                  style="border-radius: 3px 0 0 3px;border-right: none;border: 1px solid #cccccc;width:
  180px;"
                                  placeholder="输入订单号搜索">
                              <div @click="search" class="mybtn" style="border-radius: 0 3px 3px 0;">搜索</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="body">
                  <div style="padding: 10px;">
                      <Table :fields="fields" :data="orderList">
                          <template v-slot:status="cell">
                              <span :style="{color: getStatusColor(cell.value)}">{{ cell.value }}</span>
                          </template>
                      </Table>

                      <div v-if="orderList.length == 0 && !showLoading"
                          style="display: flex;align-items: center;justify-content: center;padding: 15px
  0;background-color: #fff;font-size: 14px;">
                          暂无订单
                      </div>

                      <!-- 分页 -->
                      <div class="pagination" v-if="total > 0">
                          <div class="page-info">共 {{ total }} 条记录，当前第 {{ currentPage }} 页 / 共 {{ totalPages
  }} 页</div>
                          <div class="page-btns">
                              <div @click="goPage(1)" :class="['page-btn', currentPage == 1 ? 'disabled' :
  '']">首页</div>
                              <div @click="goPage(currentPage - 1)" :class="['page-btn', currentPage == 1 ? 'disabled' :
  '']">上一页</div>
                              <div v-for="p in displayPages" :key="p" @click="goPage(p)"
                                  :class="['page-btn', currentPage == p ? 'active' : '']">{{ p }}</div>
                              <div @click="goPage(currentPage + 1)" :class="['page-btn', currentPage == totalPages ?
  'disabled' : '']">下一页</div>
                              <div @click="goPage(totalPages)" :class="['page-btn', currentPage == totalPages ?
  'disabled' : '']">末页</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </template>

  <script>
  import Table from '../components/Table/Table'

  export default {
      name: 'OrderStatus',
      components: {
          'Table': Table
      },
      data() {
          return {
              showLoading: false,
              searchValue: '',
              orderList: [],
              total: 0,
              currentPage: 1,
              pageSize: 50,
              fields: [
                  { key: 'order_id', label: '订单号', width: '150px' },
                  { key: 'thirdOrderNo', label: '第三方单号', width: '250px' },
                  { key: 'msg', label: '平台返回信息', width: '' },
                  { key: 'status', label: '订单状态', width: '120px' },
                  { key: 'createTime', label: '创建时间', width: '180px' }
              ]
          }
      },
      computed: {
          totalPages() {
              return Math.ceil(this.total / this.pageSize) || 1
          },
          displayPages() {
              const pages = []
              const total = this.totalPages
              const current = this.currentPage
              let start = Math.max(1, current - 2)
              let end = Math.min(total, start + 4)
              start = Math.max(1, end - 4)
              for (let i = start; i <= end; i++) {
                  pages.push(i)
              }
              return pages
          }
      },
      mounted() {
          this.orderList_get()
      },
      methods: {
          searchInput(e) {
              if (!this.searchValue) {
                  this.currentPage = 1
                  this.orderList_get()
              }
          },
          search() {
              this.currentPage = 1
              this.orderList_get()
          },
          goPage(page) {
              if (page < 1 || page > this.totalPages || page == this.currentPage) return
              this.currentPage = page
              this.orderList_get()
          },
          orderList_get() {
              this.showLoading = true
              this.post('get_order_status', {
                  page: this.currentPage,
                  count: this.pageSize,
                  key: this.searchValue
              }).then(({ total, items }) => {
                  this.showLoading = false
                  this.total = total
                  this.orderList = items || []
              }).catch(() => {
                  this.showLoading = false
              })
          },
          getStatusColor(status) {
              const colorMap = {
                  '待支付': '#f0ad4e',
                  '已完成': '#5cb85c',
                  '已取消': '#999999',
                  '处理中': '#2c72b0'
              }
              return colorMap[status] || '#333333'
          }
      }
  }
  </script>

  <style scoped>
  .wrapper {
      color: #333;
      background-color: #fff;
      border-radius: 3px;
      border: 1px solid #dddddd;
  }

  .header {
      background-color: #f5f5f5;
      border-bottom: 1px solid #dddddd;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      padding: 10px 15px;
      font-size: 12.5px;
      font-family: "Microsoft YaHei", SimSun;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #dddddd;
  }

  .body {}

  .mybtn {
      background-color: #2c72b0;
      padding: 5px 10px;
      font-size: 11.5px;
      cursor: pointer;
      touch-action: manipulation;
      color: #ffffff;
      user-select: none;
  }

  .mybtn:hover {
      background-color: #286090;
      color: #ffffff;
  }

  .mybtn:active {
      background-color: #1d5280;
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
  }

  input {
      outline: none;
      height: 30px;
      padding: 5px 10px;
      font-size: 12px;
      line-height: 1.5;
      border-radius: 3px;
      border: 1px solid #cccccc;
  }

  input:focus {
      border: 1px solid #3873c0 !important;
  }

  /* 分页样式 */
  .pagination {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 0;
      margin-top: 10px;
      border-top: 1px solid #eeeeee;
      font-size: 13px;
  }

  .page-info {
      color: #666;
  }

  .page-btns {
      display: flex;
      align-items: center;
      gap: 5px;
  }

  .page-btn {
      padding: 5px 12px;
      border: 1px solid #cccccc;
      border-radius: 3px;
      cursor: pointer;
      background-color: #fff;
      color: #333;
      user-select: none;
      font-size: 12px;
  }

  .page-btn:hover {
      background-color: #f5f5f5;
      border-color: #2c72b0;
      color: #2c72b0;
  }

  .page-btn.active {
      background-color: #2c72b0;
      border-color: #2c72b0;
      color: #fff;
  }

  .page-btn.disabled {
      color: #ccc;
      cursor: not-allowed;
      border-color: #ddd;
  }

  .page-btn.disabled:hover {
      background-color: #fff;
      border-color: #ddd;
      color: #ccc;
  }
  </style>